import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/* Notification-bell feed.
 *
 * One endpoint returning all three queues at once — the bell is mounted in the
 * sidebar on every screen and polls on an interval, so this stays a single
 * round trip rather than three.
 *
 * Lives on its own prefix (/api/admin-notifications) rather than under
 * /api/listings, because the feed is not only about listings: it carries
 * payments too.
 */
export const adminNotificationApi = createApi({
    reducerPath: 'adminNotificationApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin-notifications`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AdminNotifications'],
    endpoints: (build) => ({
        getAdminNotifications: build.query({
            query: () => '/',
            providesTags: ['AdminNotifications'],
        }),
    }),
});

export const { useGetAdminNotificationsQuery } = adminNotificationApi;
